import { combineReducers } from 'redux'
import footerLinksReducer from './footerLinksReducer'
import footerPageReducer from './footerPageReducer'

export default combineReducers({
  footerLinks: footerLinksReducer,
  footerPage: footerPageReducer
})
